import RE_ROUTE_VARIABLE from 'rlink-router/RE_ROUTE_VARIABLE';
import resolveChoices from 'rlink-router/resolveChoices';

export default function prepareRoutePatterns (routeDefinitions, regions, locales, defaultRegion, defaultLocale) {

  let routePatterns = [];
  let routes = {};

  for (let [routePattern, {view, params = {}, choices = {}}] of Object.entries(routeDefinitions.routes)) {
    routes[routePattern] = {
      view,
      params: Object.assign({
        region: defaultRegion,
        locale: defaultLocale,
      }, params),
      choices,
    };
    routes[`/$\{region}${routePattern}`] = {
      view,
      params: Object.assign({
        locale: defaultLocale,
      }, params),
      choices: Object.assign({
        region: regions,
      }, choices),
    };
    routes[`/$\{region}/$\{locale}${routePattern}`] = {
      view,
      params,
      choices: Object.assign({
        region: regions,
        locale: locales,
      }, choices),
    };

  }

  let routeDefinitionsWithRegionsAndLocales = {
    routes,
    choices: Object.assign({
      regions, locales,
    }, routeDefinitions.choices),
  };

  for (let [routePattern, {view, choices = {}}] of Object.entries(routeDefinitionsWithRegionsAndLocales.routes)) {
    let groupNum = 0;
    let paramNameToGroupNum = {};
    let reRoute = new RegExp('^' + routePattern.replace(RE_ROUTE_VARIABLE, (match, paramName) => {
      if (!(paramName in choices)) {
        throw new Error(`Route variable is not a choice param: ${paramName}`);
      }
      // choice param - turn into capture group
      paramNameToGroupNum[paramName] = ++groupNum;
      let resolvedChoices = resolveChoices(routeDefinitionsWithRegionsAndLocales, choices[paramName]);
      if (resolvedChoices) {
        // can hard-code alternatives
        return `(${resolvedChoices.join('|')})`;
      } else {
        // must match any
        return '([^\/]+)';
      }
    }) + '$');
    routePatterns.push({
      reRoute,
      paramNameToGroupNum,
      view,
    });
  }
  return routePatterns;
}



// WEBPACK FOOTER //
// ./lib/rlink-router/prepareRoutePatterns.js